import React, {PureComponent} from 'react';

export default class ErrorPage extends PureComponent {
    render() {
        return (

                <div className='not-found__content'>
                    <h3 className='not-found__info'>Ooops! Some Error happend, please refresh the page later :(</h3>
                </div>

        )
    }
}
